<ng-container *ngIf="widgetEnabled">
    <div
        class="penny-backdrop"
        [class.is-visible]="isOpen && isExpanded"
        (click)="onClose()"
        aria-hidden="true"></div>

    <div
        class="penny-drawer"
        [class.is-open]="isOpen"
        [class.is-expanded]="isExpanded"
        role="dialog"
        aria-label="Ask Penny, your HOA assistant">

        <header class="penny-header">
            <span class="penny-avatar" aria-hidden="true">
                <i class="ph-bold ph-sparkle icon-16" aria-hidden="true"></i>
            </span>
            <div class="penny-title-col">
                <h2 class="penny-title">{{ title }}</h2>
                <span class="penny-subtitle">{{ 'Your HOA Assistant' }}</span>
            </div>
            <button
                type="button"
                class="penny-header-btn"
                (click)="onToggleExpand()"
                [attr.aria-label]="isExpanded ? 'Collapse to drawer' : 'Expand to full screen'">
                <i
                    class="ph-bold icon-muted icon-16"
                    [class.ph-arrows-out-simple]="!isExpanded"
                    [class.ph-arrows-in-simple]="isExpanded"
                    aria-hidden="true"></i>
            </button>
            <button
                type="button"
                class="penny-header-btn"
                (click)="onClose()"
                aria-label="Close Ask Penny">
                <i class="ph-bold ph-x icon-muted icon-16" aria-hidden="true"></i>
            </button>
        </header>

        <div class="penny-body" #scrollBody (click)="onBodyClick($event)">
            <div class="penny-welcome" [innerHTML]="welcomeHtml"></div>

            <ul class="penny-chips" *ngIf="!messages.length">
                <li *ngFor="let prompt of quickPrompts; trackBy: trackByIndex" class="penny-chip-row">
                    <button type="button" class="penny-chip" (click)="onChip(prompt)">
                        <i class="ph-bold ph-arrow-elbow-down-right penny-chip-icon icon-muted icon-12" aria-hidden="true"></i>
                        <span class="penny-chip-label">{{ prompt }}</span>
                    </button>
                </li>
            </ul>

            <div class="penny-messages">
                <div
                    *ngFor="let msg of messages; trackBy: trackByIndex"
                    class="penny-msg"
                    [class.is-user]="msg.role === 'user'"
                    [class.is-assistant]="msg.role === 'assistant'">

                    <div *ngIf="msg.role === 'user'" class="penny-user-bubble">{{ msg.content }}</div>

                    <ng-container *ngIf="msg.role === 'assistant'">
                        <div class="penny-answer" [class.is-failed]="msg.failed" [innerHTML]="msg.html"></div>

                        <div class="penny-citations" *ngIf="showCitations && msg.sources?.length">
                            <ng-container *ngFor="let source of msg.sources; trackBy: trackByIndex">
                                <a *ngIf="source.url"
                                   class="penny-source-pill"
                                   [href]="source.url"
                                   target="_blank" rel="noopener noreferrer">{{ source.title }}</a>
                                <span *ngIf="!source.url" class="penny-source-pill">{{ source.title }}</span>
                            </ng-container>
                        </div>

                        <div class="penny-msg-actions" *ngIf="!msg.failed">
                            <button
                                type="button"
                                class="penny-action-btn"
                                (click)="onCopy(msg)"
                                aria-label="Copy answer">
                                <i class="ph-bold icon-14"
                                   [class.ph-copy]="!msg.copied"
                                   [class.ph-check]="msg.copied"
                                   aria-hidden="true"></i>
                            </button>
                            <button
                                type="button"
                                class="penny-action-btn"
                                [class.is-active]="msg.feedback === 'thumbs_up'"
                                [disabled]="!msg.messageId"
                                (click)="onFeedback(msg, 'thumbs_up')"
                                aria-label="Helpful answer">
                                <i class="ph-bold ph-thumbs-up icon-14" aria-hidden="true"></i>
                            </button>
                            <button
                                type="button"
                                class="penny-action-btn"
                                [class.is-active]="msg.feedback === 'thumbs_down'"
                                [disabled]="!msg.messageId"
                                (click)="onFeedback(msg, 'thumbs_down')"
                                aria-label="Unhelpful answer">
                                <i class="ph-bold ph-thumbs-down icon-14" aria-hidden="true"></i>
                            </button>
                        </div>
                    </ng-container>
                </div>

                <div class="penny-msg is-assistant" *ngIf="inFlight">
                    <div class="penny-thinking" aria-live="polite">{{ currentLoadingMessage }}</div>
                </div>
            </div>
        </div>

        <footer class="penny-footer">
            <div class="penny-composer">
                <textarea
                    #composer
                    class="penny-composer-input"
                    rows="1"
                    [(ngModel)]="draft"
                    [disabled]="inFlight"
                    (input)="autoGrow(composer)"
                    (keydown)="onComposerKeydown($event)"
                    placeholder="Ask a follow-up..."
                    aria-label="Ask Penny a question"></textarea>
                <div class="penny-composer-actions">
                    <button
                        type="button"
                        class="penny-send-btn"
                        [disabled]="inFlight || !draft.trim()"
                        (click)="onSend()"
                        aria-label="Send question">
                        <i class="ph-bold ph-arrow-up icon-16" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </footer>
    </div>
</ng-container>
